var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-bar',{attrs:{"label":"Appointment","filter-text":_vm.filterText,"reset":_vm.resetFilters}},[_c('filter-item',[_c('filter-user-attendees',{attrs:{"filter-name":"appointments","store-module":"upNext"},on:{"change":function($event){_vm.userAttendeesFilterText = $event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }